import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../config/firebase';

export function useAuthenticatedFirestore() {
  const { isAuthenticated, user } = useAuth();
  const [firestoreReady, setFirestoreReady] = useState(false);

  useEffect(() => {
    setFirestoreReady(isAuthenticated && !!user);
  }, [isAuthenticated, user]);

  return {
    db: firestoreReady ? db : null,
    isReady: firestoreReady,
    userId: user?.uid
  };
} 